module.exports = __webpack_public_path__ + "static/media/bellWhite.a702d5e6.svg";